import { AdminService } from 'src/app/services/admin.service';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SessionCleanupService } from 'src/app/services/session-cleanup.service';

export const authGuard: CanActivateFn = () => {
  const sessionCleanup = inject(SessionCleanupService);

  const admin = inject(AdminService);
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  if (
    token &&
    admin.getsessionbranchidid() > 0 &&
    admin.getsessionfinancialyearid() > 0 &&
    admin.getsessioncompanyid() > 0
  ) {
    return true;
  }

  sessionCleanup.promptSessionExpiredAndLogout(5);

  return false;
};
